package com.anjuros.website.templates.template2.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.template2.modules.Template2Review
import com.anjuros.website.templates.template2.modules.Template2Theme
import com.anjuros.website.templates.template2.modules.getColor
import com.anjuros.website.templates.template2.util.Template2Constants
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template2ReviewCard(modifier: Modifier,template2Review: Template2Review){
    // The card itself is the item in the scrolling row, so its width and no-shrink apply there.
    // (An extra wrapper box here used to be squashed to zero width, making the cards overlap.)
    Box(modifier = modifier
        .backgroundColor(rgb(250, 250, 248))
        .padding(20.px)
        .borderRadius(8.px)
        .border(
            width = 1.px,
            style = LineStyle.Solid,
            color = rgb(239,239,239)
        )
        .boxShadow(
            2.px, 2.px, 5.0.px, 1.0.px, color = rgba(250, 250, 248,.5), false
        )
    ) {
     Column(modifier = Modifier
       ,
        verticalArrangement = Arrangement.SpaceAround){

        P(
            attrs = Modifier
                .fillMaxWidth()
                .align(Alignment.CenterHorizontally)
                .fontFamily(Template2Constants.FONT_FAMILY)
                .fontSize(18.px)
                .color(Template2Theme.Primary.getColor())
                .fontWeight(FontWeight.Bold)

                .toAttrs()
        ) {
            Text(LocalText(template2Review.title))

        }
        P(
            attrs = Modifier
                .fillMaxWidth()
                .fontFamily(Template2Constants.FONT_FAMILY)
                .fontSize(16.px)
                .color(Template2Theme.Secondary.rgb)
                .fontWeight(FontWeight.Normal)
                .fontStyle(FontStyle.Italic)

                .toAttrs()
        ) {
            Text("\"${LocalText(template2Review.review)}\"")

        }

         P(
             attrs = Modifier
                 .fillMaxWidth()
                 .fontFamily(Template2Constants.FONT_FAMILY)
                 .fontSize(14.px)
                 .color(Template2Theme.DarkGrey.rgb)
                 .fontWeight(FontWeight.Bold)

                 .toAttrs()
         ) {
             Text(template2Review.author)

         }

    }


    }
}